"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validFileTypes = exports.maxFileSize = void 0;

var _validators = require("@sword-health/vuelidate/lib/validators");

var _utils = require("./utils.js");

var maxFileSize = function maxFileSize(number) {
  return _validators.helpers.withParams({
    type: "maxFileSize",
    number: number
  }, function (value) {
    return value ? value.size / Math.pow(1000, 2) <= number : true;
  });
};

exports.maxFileSize = maxFileSize;

var validFileTypes = function validFileTypes(types) {
  return _validators.helpers.withParams({
    type: "validFileTypes",
    types: types
  }, function (file) {
    if (!file || !(file.type || file.name)) {
      return true;
    }

    var fileExtensionRegex = (0, _utils.fileExtensionsToRegex)(types);
    var MIMETypeRegex = (0, _utils.MIMETypeToRegex)(types);
    var type = file.type,
        name = file.name;
    return MIMETypeRegex.test(type) || fileExtensionRegex.test(name);
  });
};

exports.validFileTypes = validFileTypes;